import React from 'react'
import ReactDOM from 'react-dom'
import './index.css'
import App from './App'
import * as serviceWorker from './serviceWorker'
import { Provider } from 'react-redux'
import store from './config'
import './fonts'
import _axios from './apiClient'

const analyticsIdValue = 'GoogleAnalytics'
const tagManagerIdValue = 'GoogleTagManager'

_axios
  .get(
    `/api/instalacion/GetGoogleAnalyticsAndTagManagerIds?analyticsId=${analyticsIdValue}&tagManagerId=${tagManagerIdValue}`
  )
  .then((response) => {
    const analyticsId = response.data.GoogleAnalytics
    const tagManagerId = response.data.GoogleTagManager

    loadGoogleScripts(analyticsId, tagManagerId)
  })
  .catch((error) => {
    console.error(error)
  })

const loadGoogleScripts = (analyticsId, tagManagerId) => {
  const googleAnalyticsScript = document.createElement('script')
  googleAnalyticsScript.src = `https://www.googletagmanager.com/gtag/js?id=${analyticsId}`
  googleAnalyticsScript.async = true

  googleAnalyticsScript.onload = () => {
    const gtagConfigScript = document.createElement('script')
    gtagConfigScript.innerHTML = `
      window.dataLayer = window.dataLayer || [];
      function gtag(){dataLayer.push(arguments);}
      gtag('js', new Date());
      gtag('config', '${analyticsId}');
    `
    document.head.appendChild(gtagConfigScript)
  }

  document.head.appendChild(googleAnalyticsScript)

  const googleTagManagerScript = document.createElement('script')
  googleTagManagerScript.src = `https://www.googletagmanager.com/gtag/js?id=${tagManagerId}`
  googleTagManagerScript.async = true

  googleTagManagerScript.onload = () => {
    const gtagConfigScript = document.createElement('script')
    gtagConfigScript.innerHTML = `
      window.dataLayer = window.dataLayer || [];
      function gtag(){dataLayer.push(arguments);}
      gtag('js', new Date());
      gtag('config', '${tagManagerId}');
      
      // Event snippet for Vista de una página conversion page
      gtag('event', 'conversion', {'send_to': '${tagManagerId}/qNFLCJHWlKkCEPex7q8B'});
    `
    document.head.appendChild(gtagConfigScript)
  }

  document.head.appendChild(googleTagManagerScript)
}

function getApp() {
  return (
    <Provider store={store}>
      <App />
    </Provider>
  )
}

ReactDOM.render(getApp(), document.getElementById('root'))
serviceWorker.unregister()
